export class Estado {
  constructor(
    public readonly Id: number,
    public readonly Nombre: string | null,
    public readonly Tipo: number,
    public readonly TipoNombre: string | null,
    public  Activo: boolean
  ) {}
}

export class SearchEstadoRequest {
  constructor(
    public readonly PageSize: number | null,
    public readonly PageNumber: number | null,
    public readonly OrderAscending: boolean | null,
    public readonly OrderFieldName: string | null,
    public readonly Nombre: string | null,
    public readonly Tipo: number | null,
    public readonly VerSoloActivos: boolean | null
  ) {}
}

export class SaveEstadoDto {
  constructor(
    public Id: number,
    public Nombre: string | null,
    public Tipo: number,
    public Activo: boolean
  ) {}
}

export class SearchEstadoResponse {
  constructor(
    public readonly count: number,
    public readonly result: Estado[]
  ) {}
}

export class TipoEstado {
  constructor(
    public readonly Id: number,
    public readonly Nombre: string
  ) {}
}
